// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.order-article-name {
  font-size: 16px;
  line-height: var(--order-list-title-line-height);
  font-family: var(--font-tusker);
  text-transform: uppercase;
  width: 100%;
}

.option-name {
  font-size: var(--order-list-option-name-font-size);
  line-height: var(--order-list-option-line-height);
  color: var(--order-list-option-name-color);
  margin: 0px 5px;
}

h4 {
  display: flex;
  flex: 1;
}

.order-item {
  padding: 8px;
  margin: 10px 10px 0px;
  border: var(--order-list-order-item-border);
  border-radius: 15px;
}
@media (max-width: 399px) {
  .order-item {
    margin: 0px 10px 0px;
  }
}
@media (min-width: 991px) {
  .order-item {
    background: white;
  }
}

.is-coupon {
  padding: 0px;
  overflow: hidden;
}
.is-coupon .add-padding {
  padding: 10px;
}

.order-image {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  position: relative;
  padding-top: 100%;
  background: var(--ion-color-secondary-tint);
}
.order-image > ion-img {
  position: absolute;
  top: 8px;
  left: 8px;
  bottom: 8px;
  right: 8px;
}

.adds-price {
  margin-left: 5px;
  color: var(--ion-color-medium);
}

ion-fab-button {
  --box-shadow: none;
}

.order-qty {
  margin: 10px 0;
}

.note {
  margin: 5px;
  font-size: small;
}

.qty__btn {
  width: 30px;
  height: 30px;
  margin: 0;
}
.qty__btn button {
  box-shadow: unset;
}
.qty__btn span {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 0;
  right: 0;
  margin: auto;
}

.price {
  margin-left: 10px;
}

.qty {
  margin: 0 15px;
  font-size: 14px;
  color: #333333;
}

.article-price {
  line-height: var(--order-list-oarticle-price-line-height);
  font-size: 16px;
  font-family: var(--font-tusker);
}

.edit-btn {
  margin-right: 5px;
}

ion-icon {
  width: 25px;
  height: 25px;
  padding: 2px;
}

app-quantity-selector {
  --quantity-selector-height: 30px;
  --quantity-selector-border-width: 0.5px;
  --quantity-selector-border-color: var(--ion-color-light);
  --quantity-selector-background: white;
  --quantity-selector-font-size: 12px;
  color: var(--ion-color-black);
  font-family: AppFontBold, sans-serif;
}

.option-name {
  font-family: AppFont, sans-serif;
  font-size: 14px;
  line-height: 150%;
  color: #5c5c5c;
}

.menge-wraper {
  margin-top: 18px;
}

.title-block {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
}
.title-block .price {
  width: 80px;
  text-align: right;
  padding-right: 10px;
}

.text-align-right {
  text-align: right;
}

.buttons_wrapper {
  display: flex;
  justify-content: flex-end;
}

app-quantity-selector h2 {
  width: 40px !important;
}

.font-size-smaller {
  font-size: 12px;
}

.line {
  width: 100%;
  fill: var(--ion-color-primary);
  height: 3px;
}
@media (min-width: 991px) {
  .line {
    display: none;
  }
}

.deposit_text {
  padding-top: 2px;
  font-size: 14px;
  font-family: Tusker, sans-serif;
  color: #878787;
  text-align: left;
}

.measurment_text {
  font-family: AppFont, sans-serif;
  font-size: 10px;
  color: #9f9f9f;
  line-height: 12px;
  padding: 5px 0px;
  text-align: left;
  text-transform: initial;
}

@media (max-width: 399px) {
  ion-col:has(.line) {
    padding: 0 5px;
  }
}

.article-price {
  text-align: right;
}

.col_price {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.col_price .article-price {
  font-size: 18px;
}

.option-quantity {
  font-size: 14px;
  line-height: var(--order-list-title-line-height);
  font-family: Tusker, sans-serif;
  font-weight: 100;
  width: 100%;
  color: var(--color-h);
}

.global-padding-left {
  padding-left: 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/order-list/order-list.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACC,eAAA;EACA,gDAAA;EACA,+BAAA;EACA,yBAAA;EACA,WAAA;AADD;;AAIA;EACC,kDAAA;EACA,iDAAA;EACA,0CAAA;EACA,eAAA;AADD;;AAIA;EACC,aAAA;EACA,OAAA;AADD;;AAIA;EACC,YAAA;EACA,qBAAA;EAEA,2CAAA;EACA,mBAAA;AAFD;AAGC;EAND;IAOE,oBAAA;EAAA;AACF;AC7BE;EDqBF;IAUE,iBAAA;EAEA;AACF;;AACA;EACC,YAAA;EACA,gBAAA;AAED;AADC;EACC,aAAA;AAGF;;AACA;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;EACA,2CAAA;AAED;AAAC;EACC,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;AAEF;;AAEA;EACC,gBAAA;EACA,8BAAA;AACD;;AAEA;EACC,kBAAA;AACD;;AAEA;EACC,cAAA;AACD;;AAEA;EACC,WAAA;EAEA,gBAAA;AAAD;;AAGA;EACC,WAAA;EACA,YAAA;EACA,SAAA;AAAD;AAEC;EACC,iBAAA;AAAF;AAGC;EACC,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;AADF;;AAKA;EACC,iBAAA;AAFD;;AAKA;EACC,cAAA;EACA,eAAA;EACA,cAAA;AAFD;;AAKA;EACC,yDAAA;EACA,eAAA;EACA,+BAAA;AAFD;;AAWA;EACC,iBAAA;AARD;;AAWA;EACC,WAAA;EACA,YAAA;EACA,YAAA;AARD;;AAWA;EACC,gCAAA;EACA,uCAAA;EACA,wDAAA;EACA,qCAAA;EACA,mCAAA;EACA,6BAAA;EACA,oCAAA;AARD;;AAWA;EACC,gCAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AARD;;AAWA;EACC,gBAAA;AARD;;AAWA;EACC,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,WAAA;AARD;AAUC;EACC,WAAA;EACA,iBAAA;EACA,mBAAA;AARF;;AAWA;EACC,iBAAA;AARD;;AAUA;EACC,aAAA;EACA,yBAAA;AAPD;;AASA;EACC,sBAAA;AAND;;AAQA;EACC,eAAA;AALD;;AAOA;EACC,WAAA;EACA,8BAAA;EACA,WAAA;AAJD;AChLE;EDiLF;IAKE,aAAA;EAFA;AACF;;AAIA;EACC,gBAAA;EACA,eAAA;EACA,+BAAA;EACA,cAAA;EACA,gBAAA;AADD;;AAGA;EACC,gCAAA;EACA,eAAA;EACA,cAAA;EAEA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;AADD;;AAKC;EADD;IAEE,cAAA;EADA;AACF;;AAIA;EACC,iBAAA;AADD;;AAGA;EACC,aAAA;EACG,mBAAA;EACA,yBAAA;AAAJ;AACC;EACC,eAAA;AACF;;AAEA;EACC,eAAA;EACG,gDAAA;EACA,+BAAA;EACH,gBAAA;EACG,WAAA;EACH,qBAAA;AACD;;AAEA;EACC,kBAAA;AACD","sourcesContent":["@import '../../../theme/mixins';\n\n.order-article-name {\n\tfont-size: 16px;\n\tline-height: var(--order-list-title-line-height);\n\tfont-family: var(--font-tusker);\n\ttext-transform: uppercase;\n\twidth: 100%;\n}\n\n.option-name {\n\tfont-size: var(--order-list-option-name-font-size);\n\tline-height: var(--order-list-option-line-height);\n\tcolor: var(--order-list-option-name-color);\n\tmargin: 0px 5px;\n}\n\nh4 {\n\tdisplay: flex;\n\tflex: 1;\n}\n\n.order-item {\n\tpadding: 8px;\n\tmargin: 10px 10px 0px;\n\n\tborder: var(--order-list-order-item-border);\n\tborder-radius: 15px;\n\t@media (max-width: 399px) {\n\t\tmargin: 0px 10px 0px;\n\t}\n\t@include desktop {\n\t\tbackground: white;\n\t}\n}\n\n.is-coupon {\n\tpadding: 0px;\n\toverflow: hidden;\n\t.add-padding {\n\t\tpadding: 10px;\n\t}\n}\n\n.order-image {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tborder-radius: 5px;\n\tposition: relative;\n\tpadding-top: 100%;\n\tbackground: var(--ion-color-secondary-tint);\n\n\t> ion-img {\n\t\tposition: absolute;\n\t\ttop: 8px;\n\t\tleft: 8px;\n\t\tbottom: 8px;\n\t\tright: 8px;\n\t}\n}\n\n.adds-price {\n\tmargin-left: 5px;\n\tcolor: var(--ion-color-medium);\n}\n\nion-fab-button {\n\t--box-shadow: none;\n}\n\n.order-qty {\n\tmargin: 10px 0;\n}\n\n.note {\n\tmargin: 5px;\n\n\tfont-size: small;\n}\n\n.qty__btn {\n\twidth: 30px;\n\theight: 30px;\n\tmargin: 0;\n\n\tbutton {\n\t\tbox-shadow: unset;\n\t}\n\n\tspan {\n\t\tposition: absolute;\n\t\ttop: 50%;\n\t\ttransform: translateY(-50%);\n\t\tleft: 0;\n\t\tright: 0;\n\t\tmargin: auto;\n\t}\n}\n\n.price {\n\tmargin-left: 10px;\n}\n\n.qty {\n\tmargin: 0 15px;\n\tfont-size: 14px;\n\tcolor: #333333;\n}\n\n.article-price {\n\tline-height: var(--order-list-oarticle-price-line-height);\n\tfont-size: 16px;\n\tfont-family: var(--font-tusker);\n}\n// .article-price-wraper {\n//   display: flex;\n//   justify-content: flex-end;\n//   align-items: center;\n\n// }\n\n.edit-btn {\n\tmargin-right: 5px;\n}\n\nion-icon {\n\twidth: 25px;\n\theight: 25px;\n\tpadding: 2px;\n}\n\napp-quantity-selector {\n\t--quantity-selector-height: 30px;\n\t--quantity-selector-border-width: 0.5px;\n\t--quantity-selector-border-color: var(--ion-color-light);\n\t--quantity-selector-background: white;\n\t--quantity-selector-font-size: 12px;\n\tcolor: var(--ion-color-black);\n\tfont-family: AppFontBold, sans-serif;\n}\n\n.option-name {\n\tfont-family: AppFont, sans-serif;\n\tfont-size: 14px;\n\tline-height: 150%;\n\tcolor: #5c5c5c;\n}\n\n.menge-wraper {\n\tmargin-top: 18px;\n}\n\n.title-block {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: flex-start;\n\twidth: 100%;\n\n\t.price {\n\t\twidth: 80px;\n\t\ttext-align: right;\n\t\tpadding-right: 10px;\n\t}\n}\n.text-align-right {\n\ttext-align: right;\n}\n.buttons_wrapper {\n\tdisplay: flex;\n\tjustify-content: flex-end;\n}\napp-quantity-selector h2 {\n\twidth: 40px !important;\n}\n.font-size-smaller {\n\tfont-size: 12px;\n}\n.line {\n\twidth: 100%;\n\tfill: var(--ion-color-primary);\n\theight: 3px;\n\t@include desktop {\n\t\tdisplay: none;\n\t}\n}\n.deposit_text {\n\tpadding-top: 2px;\n\tfont-size: 14px;\n\tfont-family: Tusker, sans-serif;\n\tcolor: #878787;\n\ttext-align: left;\n}\n.measurment_text {\n\tfont-family: AppFont, sans-serif;\n\tfont-size: 10px;\n\tcolor: #9f9f9f;\n\n\tline-height: 12px;\n\tpadding: 5px 0px;\n\ttext-align: left;\n\ttext-transform: initial;\n}\n\nion-col:has(.line) {\n\t@media (max-width: 399px) {\n\t\tpadding: 0 5px;\n\t}\n}\n\n.article-price {\n\ttext-align: right;\n}\n.col_price {\n\tdisplay: flex;\n    align-items: center;\n    justify-content: flex-end;\n\t.article-price {\n\t\tfont-size: 18px;\n\t}\n}\n.option-quantity {\n\tfont-size: 14px;\n    line-height: var(--order-list-title-line-height);\n    font-family: Tusker, sans-serif;\n\tfont-weight: 100;\n    width: 100%;\n\tcolor: var(--color-h);\n\n}\n.global-padding-left {\n\tpadding-left: 10px;\n}","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
